// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fa-bolt[data-v-475e5519]{position:absolute;top:2rem;left:1rem}@media(1200px <= width <= 1260px){.fa-bolt[data-v-475e5519]{position:static}}@media(992px <= width <= 1080px){.fa-bolt[data-v-475e5519]{position:static}}@media(min-width: 768px){.fa-bolt[data-v-475e5519]{top:-2rem}}@media(min-width: 992px){.fa-bolt[data-v-475e5519]{top:.5rem;left:-3rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
